export enum DATE_PICKER_VIEW {
    DAY = 'day',
    YEAR = 'year',
    MONTH = 'month',
}
